import * as React from 'react';

export interface CustomEditRendererState {
    isEditMode: boolean;
    isDisabled: any;
    ProfileName: any;
    CargoCareProfiles: any[];
}

var self;
export class GridDropdownCCProfileRenderer extends React.Component<any, CustomEditRendererState> {
    constructor(props: any) {
        super(props);

        this.state = {
            isEditMode: false,
            isDisabled: null,
            ProfileName: this.props.data.cargoCare,
            CargoCareProfiles: this.props.colDef.cellRendererParams.refCargoCareProfiles
        };
        self = this;
    }

    componentDidMount() {
        this.setState({ isDisabled: false });

    }
    setSaveButtonDisabled(flag) {
        this.setState({ isDisabled: flag });
    }
    
    cancelRowData(event: any) {

        this.props.onProfileNameChange(event.target.value);
        this.setState({ ProfileName: event.target.value });
        //setProfileName(event.target.value);
    }

    componentWillReceiveProps(nextprops: any) {


    }
    CargoCareProfileChange(e) {

        var Value: string = e.currentTarget.value;
        this.setState({
            ProfileName: Value
        });
        const row = this.props.data;
        row.cargoCare = Value;
    }

    public render() {
        return <div>
            <select className='form-select' id="cBoxCargoCareProfile" name="CargoCareProfile" value={this.state.ProfileName}
                onChange={e => this.CargoCareProfileChange(e)} >
                <option value="None">---None---</option>
                {
                    this.state.CargoCareProfiles.map((cp, index) =>
                        <option key={index} value={cp.CargoCareCustomerProfileCode}>{cp.CargoCareCustomerProfileCode}</option>
                    )
                }
            </select>
        </div>;
    }
}